import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ConsultancyPage() {
    pageTitle('Consultancy Services');
    const params = useParams();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <PageHeading
                title='Consultancy Services'
                bgSrc='/images/service_hero_bg.jpeg'
                pageLinkText={params.serviceDetailsId || 'Consultancy'}
            />
            <Spacing lg='145' md='80'/>
            <Div className="container">
                <SectionHeading
                    title='Consultancy Working Process'
                    subtitle='Strategic Consultancy'
                    variant='cs-style1 text-center'
                />
                <Spacing lg='90' md='45'/>
                <Div className="row">
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_1.svg'
                            title='Analysis & Discovery'
                            subtitle='We begin by thoroughly understanding your business landscape, challenges, and objectives through stakeholder interviews, document reviews, and market analysis. This comprehensive assessment establishes a clear picture of your current state.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_2.svg'
                            title='Strategic Planning'
                            subtitle='Based on our discovery findings, we develop detailed strategic recommendations tailored to your specific situation and goals. Our consultants outline implementation approaches, resource requirements, timeline projections, and expected outcomes.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_3.svg'
                            title='Implementation Support'
                            subtitle="We don't just deliver recommendations and walk away. Our consultants provide ongoing guidance throughout implementation, helping you navigate challenges, make informed decisions, and adjust strategies as needed to ensure successful execution."
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='120' md='50'/>
            <Div className="container">
                <Div className="row">
                    <Div className="col-lg-6">
                        <h2 className="cs-font_30 cs-m0">Expert guidance for complex challenges</h2>
                        <Spacing lg='30' md='30'/>
                        <p>At ACE Cloud Solution, our consultancy services provide expert guidance to navigate digital transformation and maximize technology investments. Our seasoned consultants work as an extension of your team, delivering actionable insights and strategic direction.</p>
                        <p>We combine deep industry knowledge with technical expertise to help you identify opportunities, overcome challenges, and achieve your business objectives. Our consultants bring fresh perspectives and proven methodologies to drive sustainable results.</p>
                        <Spacing lg='30' md='30'/>
                        <h3 className="cs-font_22 cs-m0">Key benefits of our consultancy:</h3>
                        <Spacing lg='15' md='15'/>
                        <ul className="cs-list cs-style1">
                            <li>Objective, expert advice from seasoned professionals</li>
                            <li>Tailored strategies aligned with your unique needs</li>
                            <li>Actionable roadmaps with clear implementation steps</li>
                            <li>Ongoing support throughout execution phases</li>
                            <li>Knowledge transfer to build internal capabilities</li>
                        </ul>
                    </Div>
                    <Div className="col-lg-5 offset-lg-1">
                        <Div className="cs-image_layer cs-style1">
                            <Div className="cs-image_layer_in">
                                <img src="/images/service_5.jpeg" alt="Consultancy Services" className="w-100" />
                            </Div>
                        </Div>
                        <Spacing lg='0' md='40'/>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='100' md='80'/>
            <Div className="container">
                <Div className="row align-items-center">
                    <Div className="col-xl-5 col-lg-6">
                        <Div className="cs-radius_15 cs-shine_hover_1">
                            <img src="/images/service_img_1.jpeg" alt="Service" className='cs-radius_15 w-100' />
                        </Div>
                        <Spacing lg='0' md='40'/>
                    </Div>
                    <Div className="col-lg-6 offset-xl-1">
                        <h2 className="cs-font_50 cs-m0">Below our most consultancy related services</h2>
                        <Spacing lg='50' md='30'/>
                        <Div className="row">
                            <Div className="col-lg-6">
                                <Button btnLink='' btnText='Digital transformation' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='IT strategy & roadmapping' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Process optimization' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='IT governance & compliance' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Change management' variant='cs-type2'/>
                                <Spacing lg='0' md='10'/>
                            </Div>
                            <Div className="col-lg-6">
                                <Button btnLink='' btnText='Vendor selection' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Technology due diligence' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Innovation workshops' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Digital maturity assessment' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Executive advisory services' variant='cs-type2'/>
                                <Spacing lg='0' md='10'/>
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80'/>
            {/*<TestimonialSlider />*/}
            <Spacing lg='145' md='80'/>
            <Div className="container cs-shape_wrap_4">
                <Div className="cs-shape_4"></Div>
                <Div className="cs-shape_4"></Div>
                <Div className="container">
                    <Div className="row">
                        <Div className="col-xl-5 col-lg-6">
                            <SectionHeading
                                title='Some pre questions and answers'
                                subtitle="FAQ's"
              />
              <Spacing lg='90' md='45'/>
                        </Div>
                        <Div className="col-lg-6 offset-xl-1">
                            <Accordion/>
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80'/>
            <Div className="container">
                <Cta
                    title="Let's solve your <br />challenges <i>together</i>"
                    btnText='Schedule a Consultation'
                    btnLink='/contact'
                    bgSrc='/images/cta_bg.jpeg'
                    />
            </Div>
        </>
    )
}